import { render, staticRenderFns } from "./AnswerRating.vue?vue&type=template&id=4fa428dc"
import script from "./AnswerRating.vue?vue&type=script&lang=js"
export * from "./AnswerRating.vue?vue&type=script&lang=js"
import style0 from "./AnswerRating.vue?vue&type=style&index=0&id=4fa428dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports